import React, { useEffect, useState } from 'react'
import { ChevronLeft, Check, ArrowLeft, LayoutDashboard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SelectTopicLoader from './../Components/Loaders/SelectTopicLoader';
import api from '../api'
import Bg from '../Components/background/Bg'
import ThemeChanger from '../Components/ThemeChanger'

export default function TopicSelectionPage() {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [topics, setTopics] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [selectedSubTopic, setSelectedSubTopic] = useState(null);
  const [showCommonRoadmapPopup, setShowCommonRoadmapPopup] = useState(false);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  const [subTopics, setSubTopics] = useState({});

  async function getAllSubtopics(topicId) {
    api.get(`/user/get-all-subtopics?topicId=${topicId}`).then((res) => {
      const response = res.data
      const subtopics = response.data
      setSubTopics((prevState) => {
        return {
          ...prevState,
          [topicId]: subtopics,
        }
      })
    })
  }
  async function checkAllowedCreate() {
    api.get("/user/is-allowed-create").then((res) => {
      const response = res.data;
      if (response.statusCode === 401) {
        navigate("/login");
      } else if (response.statusCode === 405) {
        navigate("/bmc");
      } else if (response.statusCode === 200) {
        fetchTopics();
      }
    })
  }
  async function fetchTopics() {
    api.get("/user/get-all-topics").then((res) => {
      const response = res.data;
      if (response.statusCode === 401) {
        navigate("/login");
      }
      setTopics(response.data);
      response.data.forEach((item) => {
        getAllSubtopics(item._id)
      })
    }).finally(() => {
      setLoader(false);
    })
  }

  const handleCategorySelect = (categoryId) => {
    setSelectedTopic(categoryId);
  };

  const handleConfirmCategory = () => {
    setIsConfirmed(true);
    // Set the topics to the subtopics of the selected topic
    if (subTopics[selectedTopic]) {
      setTopics(subTopics[selectedTopic]);
    }
  };

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };

  const handleReset = () => {
    // Reset the state and fetch the main topics again
    setSelectedTopic(null);
    setIsConfirmed(false);
    setSelectedSubTopic(null);
    fetchTopics();
  };

  const handleTopicSelect = (topic) => {
    setSelectedSubTopic(topic);
  };

  const openCommonRoadmapPopup = () => {
    setShowCommonRoadmapPopup(true);
  };

  const handleGenerateCommonRoadmap = () => {
    if (selectedSubTopic && selectedTopic) {
      const userSelectedTopic = selectedTopic;
      const userSelectedSubTopic = selectedSubTopic._id;
      
      api.post("/roadmap/common-roadmap/save-roadmap", {
        topicId: userSelectedTopic,
        subTopicId: userSelectedSubTopic
      }).then(res => {
        const response = res.data;
        if (response.statusCode === 200) {
          navigate(`/loading-roadmap-common/${response.data}`)
        } else {
          console.log("error corrected");
          console.log(res);
        }
      })
    }
  };

  const handleGenerateRoadMap = () => {
    const topicId = selectedTopic
    const subTopicId = selectedSubTopic._id
    navigate(`/quiz-settings/${topicId}/${subTopicId}`);
  }

  useEffect(() => {
    checkAllowedCreate()

  }, []);


  return (
    <div className="min-h-screen w-screen bg-base-200 p-4 sm:p-6 lg:p-8 relative flex justify-center items-start">
      <Bg />

      <div className="w-full max-w-4xl absolute z-10 bg-base-100 p-4 sm:p-6 lg:p-8 rounded-xl shadow-md border border-neutral">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
          <h1 className="text-2xl font-bold">Topic Selection</h1>
          <div className="flex justify-center items-center gap-3">
            <ThemeChanger />
            <button
              onClick={handleBackToDashboard}
              className="btn btn-outline btn-info gap-2 btn-sm sm:btn-md"
            >
              <LayoutDashboard size={18} />
            </button>
          </div>

        </div>

        {/* Loader */}
        {loader && <SelectTopicLoader />}

        {!isConfirmed && !loader && (
          <div className="bg-base-100 rounded-xl shadow-sm p-4 sm:p-6 mb-6">
            <h2 className="text-xl font-medium mb-4">Select a Topic</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {topics.map((topic) => (
                <div
                  key={topic._id}
                  onClick={() => handleCategorySelect(topic._id)}
                  className={`p-4 rounded-lg cursor-pointer transition-all border-2   ${selectedTopic === topic._id
                      ? 'bg-primary/10 border-primary'
                      : 'bg-base-200 hover:bg-base-300 border-base-300'
                    }`}
                >
                  <h3 className="font-medium">{topic.name}</h3>
                </div>
              ))}
            </div>
            <div className="flex justify-end">
              <button
                onClick={handleConfirmCategory}
                disabled={!selectedTopic}
                className="btn btn-primary gap-2 btn-sm sm:btn-md"
              >
                <Check size={18} />
                <span>Confirm Selection</span>
              </button>
            </div>
          </div>
        )}

        {/* Step 2: Select SubTopic */}
        {isConfirmed && !loader && (
          <div className="bg-base-100 rounded-xl shadow-sm p-4 sm:p-6">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">

                <h2 className="text-lg sm:text-xl font-medium truncate">Select SubTopic</h2>

              </div>
              <button onClick={handleReset} className="btn btn-ghost btn-sm">
                <ChevronLeft size={18} />
                <p>Back</p>
              </button>
            </div>

            {isLoading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                {[...Array(6)].map((_, idx) => (
                  <div key={idx} className="h-20 bg-base-200 rounded-lg animate-pulse"></div>
                ))}
              </div>
            ) : (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                  {topics.map((topic) => (
                    <div
                      key={topic._id}
                      onClick={() => handleTopicSelect(topic)}
                      className={`p-4 rounded-lg cursor-pointer border-2 transition-colors ${selectedSubTopic && selectedSubTopic._id === topic._id
                          ? 'bg-primary/10 border-primary'
                          : 'bg-base-200 hover:bg-base-300 border-base-300'
                        }`}
                    >
                      <h3 className="font-medium">{topic.title || topic.name}</h3>
                    </div>
                  ))}
                </div>

                {selectedSubTopic && selectedTopic && (
                  <div className="flex flex-col sm:flex-row justify-center mt-8 gap-3">
                    <button
                      onClick={handleGenerateRoadMap}
                      className="btn btn-primary btn-sm sm:btn-md"
                    >
                      Generate Personalized RoadMap
                    </button>
                    <button
                      onClick={openCommonRoadmapPopup}
                      className="btn btn-secondary btn-sm sm:btn-md"
                    >
                      Generate Common RoadMap
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>

      {/* Common Roadmap Popup */}
      {showCommonRoadmapPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-base-100 rounded-xl p-6 max-w-md w-full shadow-lg">
            <h3 className="text-xl font-bold mb-2">Generate Common Roadmap</h3>
            <p className="mb-6 text-base-content/80">
              You're about to generate a common roadmap for{' '}
              <span className="font-semibold">{selectedSubTopic?.title || selectedSubTopic?.name}</span>{' '}
              in{' '}
              <span className="font-semibold">
                {topics.find((t) => t._id === selectedTopic)?.name}
              </span>
              . This will create a standard learning path without personalization based on your skill
              level.
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="btn btn-ghost"
                onClick={() => setShowCommonRoadmapPopup(false)}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleGenerateCommonRoadmap}>
                Generate Roadmap
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}